import template from './price-and-deal-terms.jade';
import priceAndDealTermsController from './price-and-deal-terms.controller';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {
      category: '@',
      categoryInfo: '=',
      ad: '=',
      form: '=',
    },
    controller: priceAndDealTermsController,
    controllerAs: 'priceAndDealTermsCtrl',
    replace: true,
  };
};
